<template>
    <div class="container">
        <transition name="fade" mode="out-in">
            <router-view 
            :key="$route.fullPath"
            :user="user"
            :api="api" />
        </transition>
        <login  v-if="login"
        :show="login"
        :redirectPath="'/admin'" />
    </div>
</template>

<script>
import UserService from '@/services/user.service.js';
import Swal from 'sweetalert2';
import Login from '@/views/Login'

export default {
    name:'AdminLayout',
    data:()=>({
        login:false
    }),
    created() {
        var user = this.$store.state.auth.user
        if (user) {
            UserService.verifyIsStaff()
                .catch(() => {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Permiso Denegado',
                    }).then(()=>{
                        this.$router.push('/')
                    })
                })
        } else {
            this.login=true
        }
    },
    components: {
        Login
    },
    computed: {
        api() {
            return this.$store.getters.GetApiPath
        },
        user() {
            return this.$store.state.auth.user;
        },
    }
}
</script>